<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 顶部菜单 -->
        <a-menu v-model="current" mode="horizontal" style="margin-bottom: 20px;">
          <a-menu-item key="RcRecord">生码记录</a-menu-item>
          <a-menu-item key="AfVerificationRecord">防伪验证记录</a-menu-item>
        </a-menu>
        <component :is="currentComponent"></component>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
  import RcRecord from './rcRecord.vue' // 引入 - 生码记录
  import AfVerificationRecord from './afVerificationRecord.vue' // 引入 - 防伪验证记录
import { watch } from 'vue'
  export default {
    components: {
      RcRecord, // 注册 - 生码记录
      AfVerificationRecord // 注册 - 防伪验证记录
    },
    data() {
      return {
        current: ['RcRecord'],
        currentComponent: 'RcRecord',
        cardStyle: '{}'
      }
    },
    watch: {
      current(newCurrent) {
        this.currentComponent = newCurrent[0] // 切换显示内容
      }
    }
  }
</script>